import { render, staticRenderFns } from "./TableBusy.vue?vue&type=template&id=26c41279&scoped=true&"
var script = {}
import style0 from "./TableBusy.vue?vue&type=style&index=0&id=26c41279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c41279",
  null
  
)

export default component.exports